<template>
  <v-main class="product-detail-page">
    <v-app-bar app flat light color="white">
      <AppbarBackIcon />
      <v-toolbar-title class="font-weight-bold">
        <span>商品</span>
        <span v-if="id"></span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn v-if="!isCreate" color="red" class="ml-4" outlined small @click="onDelete">删除</v-btn>
    </v-app-bar>
    <v-container fluid>
      <v-row dense>
        <v-col cols="6">
          <v-text-field label="名称" hint="例如：一年会员" class="required" v-model="form.name" />
        </v-col>
        <v-col cols="6">
          <v-text-field label="商品顶部标语" hint="例如：仅XX元每月" v-model="form.ui_banner" />
        </v-col>
      </v-row>
      <v-row dense class="row-price">
        <v-select class="select-price required" label="价格" hint="可在「价格表」页面配置价格选项" v-model="form.price_tier_key"
          :items="price_option_s"></v-select>
        <v-checkbox class="check-onsale" label="在售" v-model="form.is_onsale" />
        <v-checkbox class="check-redeem" label="可兑换" v-model="form.is_redeem" />
      </v-row>
      <v-row dense>
        <v-col cols="6">
          <v-text-field label="商品底部划线价" hint="例如：原价XX元" v-model="form.ui_hint_price" />
        </v-col>
        <v-col cols="6">
          <v-text-field label="商品底部提示语" hint="例如：超值特惠" v-model="form.ui_hint_text" />
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12">
          <v-text-field label="商品描述" hint="一句话描述，展示在商品列表下方" v-model="form.description" />
        </v-col>
      </v-row>
      <v-btn width="100%" color="primary" class="mt-8" @click="onSave">保存</v-btn>
      <ProductEquity v-if="!isCreate && product" :productId="id" class="mt-16" />
    </v-container>
  </v-main>
</template>

<script>
import AppbarBackIcon from '@/components/AppbarBackIcon.vue'
import { homeStore } from '@/store/home'
import _ from 'lodash'
import { equityStore } from '@/store/equity'
import { productStore } from '@/store/product'
import ProductEquity from './ProductEquity.vue'
import { priceTableStore } from '@/store/priceTable'
import { formatPrice } from '@/plugins/price'

export default {
  name: 'ProductDetailPage',
  components: { AppbarBackIcon, ProductEquity },
  data() {
    return {
      form: {
        name: null,
        description: null,
        ui_banner: null,
        ui_hint_price: null,
        ui_hint_text: null,
        price_tier_key: null,
        is_onsale: true,
        is_redeem: true,
      },
    }
  },
  computed: {
    id() {
      return this.$route.query.id || null
    },
    isCreate() {
      return _.isNil(this.id)
    },
    product() {
      return productStore.get(this.id)
    },
    price_option_s() {
      let currency = priceTableStore.main_currency
      return Object.entries(priceTableStore.tier_d).map(([key, item]) => {
        let price = item.price_d[currency]?.price
        let priceStr = formatPrice(price, currency)
        return {
          text: `级别${key}: ${priceStr} CNY`,
          value: key,
        }
      })
    },
  },
  async mounted() {
    await homeStore.doLoad()
    await productStore.doLoad()
    await equityStore.doLoad()
    if (!this.isCreate && this.product) {
      this.form.name = this.product.name
      this.form.description = this.product.description
      this.form.ui_banner = this.product.ui_banner
      this.form.ui_hint_price = this.product.ui_hint_price
      this.form.ui_hint_text = this.product.ui_hint_text
      this.form.price_tier_key = this.product.price_tier_key
      this.form.is_onsale = this.product.is_onsale
      this.form.is_redeem = this.product.is_redeem
    }
  },
  methods: {
    async onSave() {
      if (this.isCreate) {
        let product = await productStore.doCreate(this.form)
        this.$router.replace({ query: { id: product.id } })
      } else {
        await productStore.doUpdate({
          id: this.id,
          ...this.form,
        })
      }
      this.$toasted.success('保存成功')
    },
    async onDelete() {
      const msg = `确定要删除商品「${this.product.name}」吗`
      if (!(await this.$dialog.confirm({ text: msg }))) {
        return
      }
      await productStore.doDelete(this.id)
      this.$toasted.success('删除成功')
      this.$router.back()
    },
  },
}
</script>

<style lang="less" scoped>
.row-price {
  .select-price {
    flex: 1;
  }

  .check-onsale,
  .check-redeem {
    margin-left: 24px;
  }

  .check-redeem {
    margin-right: 4px;
  }
}
</style>
